import axios from 'axios';
import { API_CONFIG } from './config';
import { setupAuthInterceptor } from './interceptors/auth.interceptor';
import { setupErrorInterceptor } from './interceptors/error.interceptor';

const createApiClient = () => {
  const client = axios.create({
    ...API_CONFIG,
    headers: {
      ...API_CONFIG.headers,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  setupAuthInterceptor(client);
  setupErrorInterceptor(client);

  return client;
};

export const httpClient = createApiClient();
